import withPopover from "./withPopover";
const defaultProps = {
    showEvent: {
        name: "dxhoverstart",
        delay: 350
    },
    hideEvent: "dxhoverend",
    container: document.body,
    position: "top",
    popoverClassName: "dark-popover font-small",
    popoverContent: "",
    ignoreHidingWhenChanged: true
};
export default function withTooltip(WrappedComponent) {
    const Hoc = withPopover(WrappedComponent);
    Hoc.defaultProps = defaultProps;
    return Hoc;
}
